import ProductPresentation from "./ProductPresentation";

export default ProductPresentation;